import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { ComponentsModule } from "../../../components/components.module";
import { StandingOrderPage } from "./standing-orders";

@NgModule({
  declarations: [StandingOrderPage],
  imports: [
    IonicPageModule.forChild(StandingOrderPage),
    TranslateModule.forChild(),
    ComponentsModule,
  ],
})
export class StandingOrderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/orders/standing-orders/standing-orders.module.ts